import { MC_DEVICE_TYPE, MC_FAULT_TYPE, MC_SOFTWARE_TYPE, MC_WIHT_DELTAT, METER_TYPE } from "config/const";
import moment from "moment";
import imageCompression from "browser-image-compression";


export const lineText = (text) => {
  const newText = text
    ?.split("\n")
    ?.map((str, idx) => <p key={idx} style={{ margin: 0 }}>{str}</p>);
  return newText;
};

export const listTolineText = (list) => {
  const newText = list?.map((text) =>
    text?.split("\n")?.map((str, idx) => <p key={idx} style={{ margin: 0 }}>{str}</p>)
  );
  return newText;
};

export const findKeyByValue = (obj, targetValue) => {
  for (let key in obj) {
    if (obj[key] === targetValue) {
      return key;
    }
  }
  return null;
};

export const sum = (arr, type) => {
  let sumNum = 0;
  if (arr?.length > 0) {
    arr?.map((service) => {
      if (!isNaN(service[type])) {
        sumNum = sumNum + service[type];
      }
    });
  }
  return sumNum;
};

//** Cookies */
export const setCookie = (name, value, days = 1) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = `${name}=${value || ""}${expires}; path=/`;
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts?.length === 2) return parts.pop().split(";").shift();
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

export const currencyFormat = (number) =>
  new Intl.NumberFormat("en-IL", { style: "currency", currency: "ILS", }).format(number);


export const removeRandomChars = (str, num) => {
  let result = "";
  let i = 0;

  while (i < str?.length) {
    result += str[i];
    i++;
    if ((i + 1) % (num + 1) === 0) {
      i++;
    }
  }

  return result;
};

export const sortArray = (array, key = null, descending = false) => {
  const getValue = (obj, path) =>
    Array.isArray(path)
      ? path.reduce((acc, curr) => acc?.[curr], obj)
      : path
        ? path.split('.').reduce((acc, curr) => acc?.[curr], obj)
        : obj;

  return array.sort((a, b) => {
    const valueA = getValue(a, key);
    const valueB = getValue(b, key);

    if (valueA < valueB) return descending ? 1 : -1;
    if (valueA > valueB) return descending ? -1 : 1;
    return 0;
  });
};

export const shuffleArray = (arr) => {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export const changeCase = (str, type = "upperCase") => {
  return str.split('')
    .map(char => {
      if (type === "lowerCase") {
        return char.toLowerCase();
      } else if (type === "upperCase") {
        return char.toUpperCase();
      }
    })
    .join('');
}

export const getFromLocalStorage = (key) => {
  const data = localStorage.getItem(key);
  if (!data) return null;

  try {
    const parsed = JSON.parse(data);
    return parsed;
  }
  catch {
    return data;
  }
};

export const getMaxItemByKey = (list, key) => {
  if (!Array.isArray(list) || list.length === 0) {
    return null;
  }

  return list.reduce((maxItem, currentItem) => {
    return currentItem[key] > (maxItem?.[key] ?? -Infinity) ? currentItem : maxItem;
  }, null);
}

export const groupBy = (array, path) => {
  return array.reduce((result, item) => {
    const groupKey = getValueByPath(item, path);
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    result[groupKey].push(item);
    return result;
  }, {});
}

export const getValueByPath = (object, path) => {
  return path.split('.').reduce((acc, key) => acc && acc[key], object);
}

export const findMeterQtyi18Key = (type) => {
  let value = ``
  const meterType = findKeyByValue(METER_TYPE, type)

  if (meterType)
    value = `${meterType}_QTY`
  return value

}

export const createDateWithTime = (dateOrTime, timeString) => {
  if (timeString) {
    return moment().set({
      hour: parseInt(timeString.split(":")[0]),
      minute: parseInt(timeString.split(":")[1])
    });
  }

  if (dateOrTime && timeString) {
    return moment(dateOrTime).set({
      hour: parseInt(timeString.split(":")[0]),
      minute: parseInt(timeString.split(":")[1])
    });
  }
  return moment(dateOrTime);
}

export const calculateConsumption = (readings) => {
  if (!Array.isArray(readings) || readings.length === 0) return readings;

  // חלוקה לקבוצות לפי id
  const groupedById = readings.reduce((acc, reading) => {
    const id = reading?.meter?._id || reading?.meter?.id;
    if (!acc[id]) acc[id] = [];
    acc[id].push(reading);
    return acc;
  }, {});

  // חישוב הצריכה לכל קבוצה בנפרד
  const result = Object.values(groupedById).flatMap(group => {
    // סידור הקבוצה לפי created מהכי מוקדם להכי מאוחר
    const sortedGroup = group.sort((a, b) => new Date(a.created) - new Date(b.created));

    return sortedGroup.map((reading, index) => {
      const firstReadValue = reading?.meter?.firstReadValue ?? 0
      const consumption = index === 0
        ? firstReadValue - reading.readValue
        : reading.readValue - sortedGroup[index - 1].readValue;
      return { ...reading, consumption: Math.abs(consumption) };
    });
  });

  return result;
}

export const createGoogleCalendarLink = ({
  title,
  location,
  description,
  start,
  end,
  allDay = false,
}) => {
  if (!title) throw new Error("חסר שם אירוע (title)");
  if (!start) throw new Error("חסר תאריך התחלה (start)");
  if (!end) throw new Error("חסר תאריך סיום (end)");

  const formatDate = (date, allDayFormat = false) => {
    const m = moment(date);
    if (!m.isValid()) throw new Error("תאריך לא תקין");
    return allDayFormat
      ? m.format("YYYYMMDD")
      : m.utc().format("YYYYMMDDTHHmmss") + "Z";
  };

  const base = "https://calendar.google.com/calendar/render?action=TEMPLATE";

  const params = new URLSearchParams({
    text: title,
  });

  if (description) params.append("details", description);
  if (location) params.append("location", location);

  if (allDay) {
    const startStr = formatDate(start, true);
    const endStr = formatDate(end, true);
    params.append("dates", `${startStr}/${endStr}`);
  } else {
    const startStr = formatDate(start);
    const endStr = formatDate(end);
    params.append("dates", `${startStr}/${endStr}`);
  }

  return `${base}&${params.toString()}`;
}

export const getMcHadarColor = (mc) => {
  let color = 'primary.light'
  if (mc?.fault) {
    if (mc?.fault === MC_FAULT_TYPE.CLOGGED_FILTER)
      color = 'warning.light'
    else
      color = 'error.light'
  }
  else if (mc?.turnOnDate) {
    color = 'success.light'
  }
  return color
}

export const hasDeltaT = (mc) => {
  return MC_WIHT_DELTAT.includes(mc?.softwareType)
}

export const getMcEffective = (mc) => {
  if (!hasDeltaT(mc)) return null;
  const sen1 = mc?.sensors?.find(s => s?.number === '1')?.value
  const sen2 = mc?.sensors?.find(s => s?.number === '2')?.value
  let delta = sen1 && sen2 ? Math.abs(parseFloat(sen1 - sen2).toFixed(2)) : null
  return getEffective(delta)
}

export const getEffective = (delta) => {
  if (delta == null || delta < 2) return null

  const d = Math.floor(delta)

  if (d <= 3) return 30
  if (d <= 4) return 40
  if (d <= 5) return 50
  if (d <= 6) return 60
  if (d <= 7) return 70
  if (d <= 8) return 80
  if (d <= 9) return 90
  if (d <= 10) return 100
  if (d <= 11) return 90
  if (d <= 12) return 80
  if (d <= 13) return 70
  if (d <= 14) return 60
  if (d <= 15) return 50
  if (d <= 16) return 40
  if (d <= 17) return 30
  if (d >= 18) return 0
  return null
}

export const getEffectiveColor = (effective) => {
  return !Number.isFinite(effective)
    ? "primary.text"
    : effective <= 30
      ? "error.text"
      : effective <= 60
        ? "warning.main"
        : "success.main"
}

export const isAppleDevice = () => {
  return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
};

export const getFileType = (file) => {
  let value = null
  if (file?.mimeType?.startsWith("image/")) value = "image"
  if (file?.mimeType?.startsWith("video/")) value = "video"
  if (file?.mimeType === "application/pdf") value = "pdf"
  return value
}

export const compressImageFile = async (file) => {
  const options = {
    maxSizeMB: 2,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    initialQuality: 0.5
  };

  const compressedFile = await imageCompression(file, options);
  return compressedFile;
};

export const openPdfInNewTab = async (url) => {
  const newTab = window.open("", "_blank");

  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error("Failed to fetch PDF");

    const blob = await res.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    if (newTab) {
      newTab.location.href = blobUrl;
    }
  } catch (err) {
    console.error(err);
    if (newTab) {
      newTab.close();
    }
  }
};

export const getFaultBgcolor = (fault) => {
  if (fault === MC_FAULT_TYPE.CLOGGED_FILTER) return "#fce6c8"
  if (fault) return "error.light"
  return ""
}